export enum UnlockableFeature {
   // default
   None,

      // development
   ManualDeployments,
   ManualTesting,
   ManualBugFixes,
   DevelopmentHiringTier1,
   DevelopmentHiringTier2,
   DevelopmentHiringTier3,
   SelfImprovement,

      //biz
   Incorporation,

      // hr
   HrHiringTier1,
}



// WEBPACK FOOTER //
// ./src/app/models/achievements/unlockable-feature.enum.ts